import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { finalize, Observable, tap } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CommonService } from 'src/app/services/common.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService,
    private commonService:CommonService,
     private loaderService:LoaderService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const currentUser = this.authenticationService.currentUserValue;
      const skipLoader = request.headers.get('X-Skip-Loader') === 'true';
      if(!skipLoader){
        this.loaderService.startLoading();
      }
      
      const headers: { [key: string]: string } = {
        'X-Client-Type': 'INT'
      };
      if (currentUser && currentUser.token && !this.authenticationService.isRefresh) {
          headers['Authorization'] = `Bearer ${currentUser.token}`;
      }
      
      request = request.clone({
          headers: request.headers.delete('X-Skip-Loader'),
          setHeaders: headers
      });

      return next.handle(request).pipe(
        tap(res =>{
          if(res instanceof HttpResponse){}
        }),
        finalize(()=>{
          if(!skipLoader){
            this.loaderService.stopLoading();
          }
        })
      );
  }
}
